import { detectEnvironment } from '@/shared/lib/detectEnvironment';

export const BASE_USER_CONFIG_API_URL = '/config/gxgo';

const STAGING_CONFIG_SUFFIX = '_staging';

export const getUserConfigApiUrl = () =>
  detectEnvironment() === 'staging'
    ? `${BASE_USER_CONFIG_API_URL}${STAGING_CONFIG_SUFFIX}`
    : BASE_USER_CONFIG_API_URL;
